<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo 图">
    </div>
    <p class="title">{{ $t('companyName') }}</p>
    <p class="address_tel_fax">
      <span>{{ $t('companyAddress') }}</span>
      <span>{{ $t('companyTel') }}</span>
    </p>
    <p class="email_wx">
      <span>{{ $t('companyEmail') }}</span>
      <span>{{ $t('companyWechat') }}</span>
    </p>
    <p class="copy">{{ $t('copyright', { year: currentYear }) }}</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #1e73be;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 10px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue